import type { Schema } from '@cli-types/core-engine/schema.js'
import { addFormattedTimestamps } from './add-formatted-timestamps.js'
import { getHtmlOutputFields } from './get-html-output-fields.js'
import { getSingleAllDbFields } from './get-single-all-db-fields.js'
import { sampleAdminUserSummary } from './sample-admin-user-summary.js'
import { sampleSchemaFieldValue } from './sample-schema-field-value.js'
import { sampleSingleOutputValue } from './sample-single-output-value.js'
export function createSingleDataObject(schema: Schema): Record<string, unknown> {
  const dbFields = getSingleAllDbFields(schema)
  const htmlOutputFields = getHtmlOutputFields(dbFields)

  return addFormattedTimestamps({
    ...Object.fromEntries(dbFields.map((field) => [field.name, sampleSingleOutputValue(field)])),
    ...Object.fromEntries(
      htmlOutputFields.map((field) => [
        `${field.name}Html`,
        `<p>${sampleSchemaFieldValue(field)}</p>`
      ])
    ),
    createdByUser: sampleAdminUserSummary(),
    updatedByUser: sampleAdminUserSummary()
  })
}
